export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10192.d6a700a3.jpg";